import React from 'react';
import { Button, Typography } from '@material-ui/core';
import { useTranslation } from '@michelin/central-provider';
import michelinMan from 'icons/worry-michelin.png';
import history from 'utils/history';
import { useUFOPaths } from 'utils/paths';

export interface FallbackComponentProps {
  error: Error;
  resetErrorBoundary: (...args: Array<unknown>) => void;
}

export const FallbackComponent = (props: FallbackComponentProps) => {
  const { resetErrorBoundary } = props;
  const { PATH_ORDER_LIST_TO } = useUFOPaths();
  const { t } = useTranslation();

  return (
    <div
      data-testid="fallbackComponent"
      style={{ width: '100%', height: '100%', display: 'flex', placeContent: 'center', marginTop: 16 }}
    >
      <div role="alert" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <img
          src={michelinMan}
          alt="michelin-man"
          style={{
            width: 100,
            marginRight: 20,
            objectFit: 'contain'
          }}
        />
        <div>
          <Typography variant="h4">{t('Whoops! Something went wrong!')}</Typography>
          <Button
            fullWidth
            onClick={() => {
              resetErrorBoundary();
              history.push(PATH_ORDER_LIST_TO);
            }}
            style={{ marginTop: 16 }}
          >
            {t('Return to Order list')}
          </Button>
        </div>
      </div>
    </div>
  );
};
